export default __webpack_public_path__ + "static/ResizingAD-96fbd49918a5f17a68857c76a8796e29.webm";